module.exports = __webpack_public_path__ + "img/站点管理.dd3b04b5.png";